/** Máscara CPF/CNPJ */

/**
 * @param {*} value - Valor digitado no campo
 */
const cpfMask = value => {
  const val = value.replace(/[^\d]/g, "");

  if ((val + "").length > 11) {
    return [
      /\d/,
      /\d/,
      ".",
      /\d/,
      /\d/,
      /\d/,
      ".",
      /\d/,
      /\d/,
      /\d/,
      "/",
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      "-",
      /\d/,
      /\d/
    ];
  }
  return [
    /\d/,
    /\d/,
    /\d/,
    ".",
    /\d/,
    /\d/,
    /\d/,
    ".",
    /\d/,
    /\d/,
    /\d/,
    "-",
    /\d/,
    /\d/,
    /\d/
  ];
};

export default cpfMask;



// WEBPACK FOOTER //
// ./src/components/Masks/Cpf.js